module.exports = "<div\r\n  [@toolSlideInOut]=\"toolState\"\r\n  (@toolSlideInOut.start)=\"animationStart($event)\"\r\n  (@toolSlideInOut.done)=\"animationDone($event)\">\r\n  <ng-template #target></ng-template>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/tool/toolbox/toolbox.component.html
// module id = 1104
// module chunks = 0